import React from 'react';

import { ComponentProps } from '../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../utils/styles';
import './post-link.scss';
import t from '../../labels/labelling-utils';
import IconArrowLink from '../icons/icon-arrow-link';
import { generateIntCmpFromTenant } from '../../utils/tracking-data';
import { LiveblogTenant } from '../../typings/liveblog-themes';

export interface IPostLink extends ComponentProps {
  title: string;
  imageSrc: string;
  url: string;
  CTAText?: string;
  tenant?: LiveblogTenant;
}

const classNames = (): IClassNames =>
  makeClassNames({
    PostLink: 'post-link',
    PostLink__ContentContaier: 'post-link__content-container',
    PostLink__TextContainer: 'post-link__text-container',
    PostLink__Image: 'post-link__image',
    PostLink__Title: 'post-link__title',
    PostLink__CTA: 'post-link__cta',
  });

const DEFAULT_ANALYTICS_ELEMENT = 'liveblog-preview';
const PAGE_TEMPLATE = 'liveblog';

const PostLink: React.FC<IPostLink> = ({ tenant, title, imageSrc, url, CTAText = t('post.link.cta.text') }) => {
  const intCmpValue = tenant
    ? generateIntCmpFromTenant(tenant as LiveblogTenant, `${PAGE_TEMPLATE}_${DEFAULT_ANALYTICS_ELEMENT}_null`)
    : undefined;
  const cn = classNames();
  return (
    <a
      href={url}
      title={title}
      className={cn.PostLink}
      data-intcmp={intCmpValue}
      data-analytics-element={DEFAULT_ANALYTICS_ELEMENT}
    >
      <div className={`${cn.PostLink__ContentContaier}`}>
        <img className={cn.PostLink__Image} src={imageSrc} alt={title} />
        <div className={cn.PostLink__TextContainer}>
          <h3 className={cn.PostLink__Title}>{title}</h3>
          <span className={cn.PostLink__CTA}>
            {CTAText} <IconArrowLink width={12} height={12} />
          </span>
        </div>
      </div>
    </a>
  );
};

export default PostLink;
